import type { Order } from '../types';
import {
  isOrderEffectivelyPaid,
  isPaidOrderBlockingRegisterClose,
} from './orderCloseReadiness';
import { filterOrdersForRegisterClose } from './registerCloseOrders';

export type SessionRegisterSales = { cash: number; card: number };

/**
 * Cash/card totals for the current register session close screen.
 * Uses the same paid-order rules as EOD checklist (not raw paymentStatus only).
 */
export function computeSessionRegisterSales(orders: Order[]): SessionRegisterSales {
  const sales: SessionRegisterSales = { cash: 0, card: 0 };
  for (const order of filterOrdersForRegisterClose(orders)) {
    if (!isOrderEffectivelyPaid(order)) continue;
    for (const p of order.payments ?? []) {
      if (p.paymentStatus === 'pending') continue;
      const amount = typeof p.amount === 'number' ? p.amount : 0;
      if (p.method === 'cash') sales.cash += amount;
      else if (p.method === 'card' || p.method === 'card_online') sales.card += amount;
      else if (p.method === 'account2account') sales.card += amount;
    }
  }
  return {
    cash: Math.round(sales.cash * 100) / 100,
    card: Math.round(sales.card * 100) / 100,
  };
}

/** Stable key so register-close UI only recomputes when close-relevant fields change. */
export function registerCloseOrdersSnapshotKey(orders: Order[]): string {
  if (orders.length === 0) return '';
  const parts: string[] = new Array(orders.length);
  for (let i = 0; i < orders.length; i++) {
    const o = orders[i];
    const paid = isOrderEffectivelyPaid(o) ? '1' : '0';
    const block = isPaidOrderBlockingRegisterClose(o) ? '1' : '0';
    parts[i] = `${o.id}|${o.paymentStatus}|${paid}|${block}|${o.payments?.length ?? 0}`;
  }
  return parts.join(';');
}
